// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CockpitNotificationDifferenceModel from '../../model/cockpit-notification-difference-model';
import CockpitNotificationDifferenceDTO from '../dto/cockpit-notification-difference-dto';
import dtoSchema from '../schemas/cockpit-notification-difference-schema';

export default abstract class CockpitNotificationDifferenceModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CockpitNotificationDifferenceDTO>) {
    super();
    if (data) {
      this.count = data.count;
      this.lastCreation = data.lastCreation ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  count?: number;
  /**
  * @type {date-time}
  */
  lastCreation?: string;

  static toModel(dto: DeepPartial<CockpitNotificationDifferenceDTO>): CockpitNotificationDifferenceModel;
  static toModel(dto: DeepPartial<CockpitNotificationDifferenceDTO> | undefined | null): CockpitNotificationDifferenceModel | undefined;
  static toModel(dto: DeepPartial<CockpitNotificationDifferenceDTO> | undefined | null): CockpitNotificationDifferenceModel | undefined {
    return dto ? new CockpitNotificationDifferenceModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CockpitNotificationDifferenceModel> | CockpitNotificationDifferenceModel): CockpitNotificationDifferenceDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      count: unwrapped.count,
      lastCreation: unwrapped.lastCreation,
    } as CockpitNotificationDifferenceDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CockpitNotificationDifferenceModel, can not map to CockpitNotificationDifferenceDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
